// jQuery shim - makes jQuery available globally before other modules load
import jQuery from 'jquery';
window.jQuery = window.$ = jQuery;
